<script setup>

</script>

<template>
    <svg viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
        <path class="fill-curent" fill-rule="evenodd" stroke="none" d="M 505.173645 502.216827 C 434.98877 571.668335 436.950623 765.608032 398.950653 765.608032 C 360.950653 765.608032 368.127625 571.75238 298.835938 502.216644 C 229.474899 432.611267 35.444561 440.024658 35.444561 401.024658 C 35.444561 359.024658 229.489639 366.021851 298.835693 295.878784 C 367.947998 225.972168 368.597351 33.301025 400.461517 32.491638 C 438.743195 31.519165 435.305634 226.316406 505.173889 295.878662 C 574.951233 365.350372 768.56073 354.237732 768.56073 399.237701 C 768.56073 442.237701 575.137878 432.983826 505.173645 502.216827 Z"/>
    </svg>
</template>

<style scoped>

</style>
